import CityPageTemplate from "../city-template/CityPageTemplate";
import { troyMiConfig } from "./data";

export default function TroyMIPage() {
  return <CityPageTemplate config={troyMiConfig} />;
}